module.exports = __webpack_public_path__ + "static/media/iPhone-big.1fc83c33.png";